var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifyMappingLockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.277,
    height: 16.808,
    viewBox: "0 0 15.277 16.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14733",
    "data-name": "Group 14733",
    transform: "translate(-938.764 -121.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14731",
    "data-name": "Group 14731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16233",
    "data-name": "Path 16233",
    d: "M10.5,9.888V6.827a3.827,3.827,0,0,1,7.654,0V9.888",
    transform: "translate(932.075 119)",
    fill: "none",
    stroke: "#de1037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16232",
    "data-name": "Path 16232",
    d: "M6.031,16.5H16.746a1.531,1.531,0,0,1,1.531,1.531v5.358a1.531,1.531,0,0,1-1.531,1.531H6.031A1.531,1.531,0,0,1,4.5,23.388V18.031A1.531,1.531,0,0,1,6.031,16.5Z",
    transform: "translate(935.014 112.389)",
    fill: "none",
    stroke: "#de1037",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyMappingLockIcon);
export default __webpack_public_path__ + "static/media/verifyMapping-lockIcon.ee9dd2a7063b4766e269112119c73877.svg";
export { ForwardRef as ReactComponent };